

import { Component, Inject, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApiService } from '../services/api.service';

import { MatSnackBar } from '@angular/material/snack-bar';

import { Employee } from '../model/employee.model';



@Component({

  selector: 'app-wages',

  templateUrl: './wages.component.html',

  styleUrls: ['./wages.component.scss']

})



export class WagesComponent implements OnInit {

  data: any = {

    employeeId: null,

    employeeName: '',

    salaryAmount: null,

    guno: null,

    bonus: null,

    department: '',

    paymentDate: new Date(),

    paymentMode: '',

    remarks: '',

    expId: null,

    empLoan: null,

    penalty: null,

    createdBy: null,

    createdName: ''

  };



  selectedEmployee: Employee;

  employees = [];

  filteredEmployees = [];

  employeeSearch = '';



  loggedUserName: any;

  loggedInUserId: any;

  selectedMonthYear: string;



  constructor(private apiService: ApiService, private _snackBar: MatSnackBar) {}



  ngOnInit(): void {

    this.getEmployeeDetails();

    //   this.employees[0]={

    //   "employeeId":10,

    //   "employeeName":"Akhilesh",

    //   "employeeDepartment":"ticketco"

    // }



    //   this.employees[1]={

    //   "employeeId":11,

    //   "employeeName":"Dodla",

    //   "employeeDepartment":"collector"

    // }

    //   this.employees[2]={

    //   "employeeId":52,

    //   "employeeName":"John Cena",

    //   "employeeDepartment":"management"

    // }

    //    this.filteredEmployees = [...this.employees];

  }



  filterEmployees() {

    const searchValue = this.employeeSearch.toLowerCase();

    this.filteredEmployees = this.employees.filter(emp =>

      emp.employeeName.toLowerCase().includes(searchValue)

    );

  }



  onEmployeeChange() {

    if (this.selectedEmployee) {

      this.data.employeeId = this.selectedEmployee.employeeId;

      this.data.employeeName = this.selectedEmployee.employeeName;

      this.data.department = this.selectedEmployee.employeeDepartment || '';

    }

  }



  resetForm() {

    this.selectedEmployee = null;

    this.employeeSearch = '';

    this.filteredEmployees = [...this.employees];

    this.data = {

      employeeId: null,

      employeeName: '',

      salaryAmount: null,

      guno: null,

      bonus: null,

      department: '',

      paymentDate: new Date(),

      paymentMode: '',

      remarks: '',

      expId: null,

      empLoan: null,

      penalty: null

    };

  }



  submitWage() {

    if (this.selectedEmployee) {

      this.data.employeeId = this.selectedEmployee.employeeId;

      this.data.employeeName = this.selectedEmployee.employeeName;

      this.data.department = this.selectedEmployee.employeeDepartment || '';

    }



    this.data.createdBy = window.localStorage.getItem('loggedInUser');

    this.data.createdName = this.loggedUserName;



    this.apiService.addWage(this.data).subscribe(res => {

      if (res.wageId) {

        this._snackBar.open('Wage Submitted with Id: ' + res.wageId + ' created successfully', 'Close');

      } else {

        this._snackBar.open('Error occurred while updating details', 'Close', { duration: 3000 });

      }

    });

  }

 

  getEmployeeDetails() {

    this.apiService.getEmplyees().subscribe(data => {

      this.employees = data.employees;

      this.filteredEmployees = [...this.employees];

      const loggedInUser = Number(window.localStorage.getItem('loggedInUser'));

      this.loggedInUserId = loggedInUser;

      const loggedInUserDetail = this.employees.find(emp => emp.employeeId === loggedInUser);

      this.loggedUserName = loggedInUserDetail?.employeeName || '';

    });

  }



  generateWagesForAllEmployees() {

  const confirmGeneration = confirm("This will generate wages for all employees for this wage cycle. Continue?");

  if (!confirmGeneration) return;



  let payload: any = {

    "loggedId": this.loggedInUserId,

    "loggedUserName": this.loggedUserName

  };

  if (this.selectedMonthYear) {

    payload["monthYear"] = this.selectedMonthYear;

  }



  this.apiService.generateWagesForAllEmployees(payload).subscribe(

    (res) => {

      this._snackBar.open('Wages generated for all employees.', 'Close', {

        duration: 4000,

      });

    },

    (error) => {

      this._snackBar.open('Error occurred while generating wages.', 'Close', {

        duration: 4000,

      });

    }

  );

}







}

